import { Dispatch } from 'redux';
import { intl } from '../../providers/IntlProvider';
import { addPeople, getUserDetails, queryPeople, removePeople, updatePeople, getUser } from '../../services/api';
import { ToastCategories, ToastTypes, ToastsActionTypes } from '../toasts';
import { createAircraftLogin } from '../../services/apiNew';
import { PeopleActionTypes, Person } from '.';

interface PersonPayload {
  payload: Partial<Person>;
}

export const getPeople =
  (callback: (() => void) | null = null, with_deleted = false) =>
  async (dispatch: Dispatch): Promise<void> => {
    const response = await queryPeople({ with_deleted });
    if (callback) callback();
    dispatch({
      type: PeopleActionTypes.SAVE_ALL,
      payload: response,
    });
  };

export const getSinglePerson =
  (userId: string, params: Record<string, unknown>, callback: (() => void) | null = null) =>
  async (dispatch: Dispatch): Promise<void> => {
    const response = await getUser(userId, params);
    if (response && response.statusCode > 199 && response.statusCode < 400) {
      dispatch({
        type: PeopleActionTypes.SAVE_SINGLE,
        payload: response.body,
      });
      if (callback) callback();
    } else {
      dispatch({
        type: ToastsActionTypes.ADD_TOAST,
        payload: {
          title: intl.formatMessage({ id: 'message.failedToFetchUser' }),
          type: ToastTypes.ERROR,
          category: ToastCategories.FLAG,
          message: '',
        },
      });
      if (callback) callback();
    }
  };

export const resetUserSettingsDrawer =
  () =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch({
      type: PeopleActionTypes.SAVE_SINGLE,
      payload: {},
    });
  };

export const getMe =
  () =>
  async (dispatch: Dispatch): Promise<void> => {
    const response = await getUserDetails();
    dispatch({
      type: PeopleActionTypes.SAVE,
      payload: response,
    });
  };
export const add =
  ({ payload }: PersonPayload) =>
  async (dispatch: Dispatch): Promise<void> => {
    const response = await addPeople(payload);
    if (response.statusCode > 199 && response.statusCode < 400) {
      dispatch({
        type: ToastsActionTypes.ADD_TOAST,
        payload: {
          title: intl.formatMessage({ id: 'message.newUserAdded' }),
          type: ToastTypes.SUCCESS,
          category: ToastCategories.FLASH,
          message: '',
        },
      });
      dispatch({
        type: PeopleActionTypes.SAVE,
        payload: response.body,
      });
    } else {
      dispatch({
        type: ToastsActionTypes.ADD_TOAST,
        payload: {
          title: intl.formatMessage({ id: 'message.userAlreadyExists' }),
          type: ToastTypes.ERROR,
          category: ToastCategories.FLAG,
          message: '',
        },
      });
    }
    if (response.statusCode > 199 && response.statusCode < 400) return response.body;
    return null;
  };
export const remove =
  ({ payload }: PersonPayload) =>
  async (dispatch: Dispatch): Promise<void> => {
    const response = await removePeople(payload);
    if (response && response.statusCode > 199 && response.statusCode < 400) {
      dispatch({
        type: PeopleActionTypes.REMOVE,
        payload: response
          ? {
              removedId: payload.id,
            }
          : {},
      });
      dispatch({
        type: ToastsActionTypes.ADD_TOAST,
        payload: {
          title: intl.formatMessage({ id: 'message.userDeleted' }),
          type: ToastTypes.SUCCESS,
          category: ToastCategories.FLASH,
          message: '',
        },
      });
    } else {
      dispatch({
        type: ToastsActionTypes.ADD_TOAST,
        payload: {
          title: intl.formatMessage({ id: 'message.userDeletedFailed' }),
          type: ToastTypes.ERROR,
          category: ToastCategories.FLAG,
          message: '',
        },
      });
    }
  };
export const update =
  ({ payload }: PersonPayload) =>
  async (dispatch: Dispatch): Promise<void> => {
    const response = await updatePeople(payload);
    if (response && response.statusCode > 199 && response.statusCode < 400) {
      dispatch({
        type: PeopleActionTypes.SAVE,
        payload: response.body,
      });
      dispatch({
        type: PeopleActionTypes.SAVE_SINGLE,
        payload: response.body,
      });
      dispatch({
        type: ToastsActionTypes.ADD_TOAST,
        payload: {
          title: intl.formatMessage({ id: 'message.permissionsUpdated' }),
          type: ToastTypes.SUCCESS,
          category: ToastCategories.FLASH,
          message: '',
        },
      });
    } else {
      dispatch({
        type: ToastsActionTypes.ADD_TOAST,
        payload: {
          title: intl.formatMessage({ id: 'message.failedToUpdateUser' }),
          type: ToastTypes.ERROR,
          category: ToastCategories.FLAG,
          message: '',
        },
      });
    }
  };

interface AircraftLoginParams {
  aircraft_id: string;
  email: string;
}

export const createAircraftLoginAction =
  ({ aircraft_id, email }: AircraftLoginParams) =>
  async (dispatch: Dispatch): Promise<Response> => {
    const response = await createAircraftLogin({ aircraft_id, email });
    if (response.status > 199 && response.status < 400) {
      dispatch({
        type: ToastsActionTypes.ADD_TOAST,
        payload: {
          title: intl.formatMessage({ id: 'message.addAircraftSuccess' }),
          type: ToastTypes.SUCCESS,
          category: ToastCategories.FLASH,
          message: '',
        },
      });
      return response;
    }
    const errorMessage = await response.text();
    dispatch({
      type: ToastsActionTypes.ADD_TOAST,
      payload: {
        title: intl.formatMessage({ id: 'message.addAircraftFailed' }),
        type: ToastTypes.ERROR,
        category: ToastCategories.FLAG,
        message: errorMessage || '',
      },
    });
    return response;
  };
